import { PLATFORMS } from '@domain/platform';
import { IconTrakto, IconMobees } from '@paretogroup/tess';

export const PARTNER_BOXES = [
    {
        icon: IconTrakto,
        isActive: true,
        subtitle: 'Easily create and edit layouts',
        title: PLATFORMS.TRAKTO.name,
        id: 'trakto',
    },
    {
        icon: IconMobees,
        isActive: true,
        subtitle: 'Out of Home Digital Marketing',
        title: PLATFORMS.MOBEES.name,
        id: 'mobees',
    },
];

export const PARTNERSHIPS_SECTION_TEXTS = {
    TITLE: 'Partnerships',
    SUBTITLE: 'We have partners that can leverage your campaigns in different, innovative ways. Click to find out more about them:',
};
